import styled from 'styled-components'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import { Colors } from '../../../styles'

export const Header = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
`

export const Container = styled.div`
  height: 100%;
  padding: 1px 22px;
`

export const HeaderWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
`

export const StyledDropDown = styled(DropDownList)`
  border-radius: 4px;
  background-color: white !important;
  span.k-dropdown-wrap.k-state-default {
    border-color: #dce6f9;
    background-image: none;
    background-color: transparent;
  }
`

export const StyledDatePicker = styled(DatePicker)`
  border-radius: 4px;
  border: 1.5px solid #dce6f9;
  background: white;
  span.k-picker-wrap.k-state-default.k-picker-wrap {
    padding: 0px;
  }
`

export const FilterWrapper = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${Colors.cancelTextColor};
`
export const CenteredContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const VesselName = styled.label`
  font-size: 14px;
  font-weight: 700;
  color: ${Colors.cancelTextColor};
`
export const ExportButton = styled.button`
  gap: 8px;
  height: 32px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  padding: 0 16px;
  font-weight: 400;
  width: fit-content;
  border-radius: 4px;
  align-items: center;
  color: ${Colors.deepBlue};
  background: ${Colors.white};
  border: 1px solid ${Colors.deepBlue};
`